import { emotionTheme } from '@styles/theme'

const STRIPE_COLORS = {
  budget: '#7B8794',
  deviation: '#D96060'
} as const


export const PREVIEW_STRIPE_BY_WEEK: Record<number, string> = {
  1: '#FDE2E2',
  2: '#FAC4C4',
  3: '#F79C9C',
  4: '#E98585',
  5: '#D96060'
}

const RED_CARD = {
  color: '#D96060',
  background: '#FDE2E2'
} as const

export type PreviewCardType = 'budget' | 'preview' | 'deviation'

const getPreviewStripeColor = (week?: number) =>
  (week && week >= 1 && week <= 5 ? PREVIEW_STRIPE_BY_WEEK[week] : PREVIEW_STRIPE_BY_WEEK[3]) as string

export const getColorsByType = (
  type: PreviewCardType,
  isNegative?: boolean,
  previewWeek?: number
) => {
  const previewStripeColor = getPreviewStripeColor(previewWeek)

  const BUDGET_ICON_COLOR = '#D96060'
  const BUDGET_ICON_BG = 'rgba(217, 96, 96, 0.2)' // #D96060 20%

  const colors = {
    budget: {
      text: emotionTheme.colors.secondary,
      descriptionColor: emotionTheme.colors.secondary,
      color: BUDGET_ICON_COLOR,
      background: BUDGET_ICON_BG,
      borderColor: STRIPE_COLORS.budget
    },
    preview: {
      text: emotionTheme.colors.secondary,
      descriptionColor: emotionTheme.colors.secondary,
      // Ícone igual ao deviation para garantir visibilidade (cor/fundo do ícone)
      color: isNegative ? RED_CARD.color : emotionTheme.colors.success.color,
      background: isNegative ? RED_CARD.background : emotionTheme.colors.success.background,
      borderColor: previewStripeColor
    },
    deviation: {
      text: isNegative ? RED_CARD.color : emotionTheme.colors.success.color,
      descriptionColor: emotionTheme.colors.secondary,
      color: isNegative ? RED_CARD.color : emotionTheme.colors.success.color,
      background: isNegative ? RED_CARD.background : emotionTheme.colors.success.background,
      borderColor: STRIPE_COLORS.deviation
    }
  }

  return colors[type]
}

